import * as _ from 'lodash';
import { format } from 'date-fns';
import { SharedHttpClientService } from './../../../Shared/Services/shared-http-client.service';
import { UrlsService } from './../../../Shared/Services/urls.service';

import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { UserService } from '../../../Shared/Services/user.service';
import {default as GridColumnsJSON} from './CAIS-Natural-Person-Grid-Columns.json';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { map, Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Table, TableModule  } from "primeng/table";
import { MessageService,ConfirmationService } from 'primeng/api';
import { DataService } from 'app/Shared/Services/data.service';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { AddEditViewFormComponent } from '../shared-component/add-edit-view-form/add-edit-view-form.component';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { ButtonModule } from 'primeng/button';
import { LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-cais-natural-person',
    imports: [AddEditViewFormComponent, FilterPanelComponent, QuickSearchComponent, ButtonModule, NgClass, CommonModule, TableModule,
        MatProgressSpinner, ExportToCSVSComponent, LowerCasePipe, ToastModule],
    templateUrl: './natural-person.component.html',
    styleUrls: ['./natural-person.component.scss']
})
export class NaturalPersonComponent implements OnInit, OnDestroy {
  @ViewChild(('dt')) dt!: Table;
  quickFilterArray: any = GridColumnsJSON["CAIS-Natural-Person-Quick-Search-Fields"];
  GridColumns = GridColumnsJSON["CAISNaturalPersonCols"];
  AddressGridColumns = GridColumnsJSON["AddressesDataCols"] as any[];
  dataset: any[] = [];
  ApplicationName: any = '';
  activeRecordType: string = 'STAGING';
  LastExecutionDate!: any[];
  quickFilterEventType: any;
  quickFilterEventTypeArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;
  addScreenNegotiatedFields: Array<string> = ['Id', 'Action', 'Firm', 'Active', 'Report Date', 'Report Reason', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  editScreenNegotiatedFields: Array<string> = ['Id', 'Action', 'Firm', 'Active', 'Report Date', 'Report Reason', 'Updated Date', 'Updated User', 'Created Date', 'Created User'];
  viewScreenNegotiatedFields: Array<string> = ['Id', 'Action', 'Firm', 'Active'];
  CountryFields: Array<string> = ['Foreign TID Country', 'Replacing Foreign TID Country'];
  CounryDBFields: Array<string> = ['foreignTIDCountryCd', 'replacingForeignTIDCountryCd'];
  yearField: any = ['Year Of Birth'];
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  rowsPerPageOptions: any = [];
  totalRecords!: number;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  tbldatamsg = 'L o a d i n g . . . . .';
  cols: any = []
  filterCols: any = [];
  selectedRow: any = [];
  openDialog: boolean;
  pageNumber: any = 1;
  priviousStartLimit: any;
  rowDataforDialog: any = [];
  rowIndexForDialog!: number;
  actionType!: string;
  subscription!: Subscription;
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  defaultData: any;
  addressColumns: any = [];
  addressColumnJson: any = [];
  AddressDetails: any = [];
  screenDataDetails: any = [];
  AddressDataDetails: any = [];

  constructor(private UserService: UserService,
    private urlService: UrlsService,
    private gridService: GridService,
    private messageService: MessageService,

    public confirmationService: ConfirmationService,
    public constantService: ConstantService,
    public dataService: DataService,
    private emitterService: EmitterService,
    private sortPipe: SortPipe,
    private sharedHttpClientService: SharedHttpClientService
  ) {
    this.cols = [];
    this.filterCols = [];
    this.openDialog = false;
    this.ApplicationName = this.constantService.getApplicationName();
    this.UserService.CAISFDIDRecordType = this.activeRecordType;
  }

  ngOnInit(): void {
    this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimit = this.constantService.DEFAULT_ROWSIZE;
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.rowsPerPageOptions = this.constantService.DEFAULT_ROWSPERPAGEOPTION;
    this.dataset = [];
    this.totalRecords = this.rowcount;
    this.quickFilterEventTypeArray = this.gridService.eventTypes;

    this.defaultFilter();

    this.getColumns();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe({
      next: (value:any) => {
      if (value) {
        this.getData();
      }
    }});
  }

  closeDialog(value: any) {
    if (value) {
      this.dataService.roeSelectedRecords = [];
      this.getData();
    }
    this.openDialog = false;
  }

  getColumns() {
    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }

    let addressColumn: any = this.AddressGridColumns;
    this.addressColumnJson = [];
    if (addressColumn != null || addressColumn != undefined) {
      this.addressColumns = this.gridService.getGridColumns(addressColumn);
      /* Adding Country & Region Code Menus */
      if(this.addressColumns.length > 0) {
        for(let i=0; i < this.addressColumns.length; i++) {
          if(this.addressColumns[i]["header"] === "Country Code") {
            this.addressColumns[i]["dropdownvalue"] = this.UserService.countryList;
          } else if(this.addressColumns[i]["header"] === "Region Code") {
            this.addressColumns[i]["dropdownvalue"] = this.UserService.countryRegionList;
          }
        }
      }
    }
  }

  getRecordTypeData(recordType: any) {
    let recordTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Record Type');
    this.DefaultFilterArray[recordTypeIndex].values = recordType;
    this.DefaultFilterArray = [...this.DefaultFilterArray];
    this.FilterApplyFilterEvent(this.DefaultFilterArray);
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;

    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt.first = 1; // Reset Selected Page to Initial Page

    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;

    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.dt.first = 1; // Reset Selected Page to Initial Page

    this.getData();
  }

  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;

    /* Set Record Type  */
    let recordTypeIndex = this.DefaultFilterArray.findIndex((filterElem: { label: string; }) => filterElem.label === 'Record Type');
    this.activeRecordType = this.DefaultFilterArray[recordTypeIndex].values;
    this.UserService.CAISFDIDRecordType = this.DefaultFilterArray[recordTypeIndex].values;

    this.startLimit = 0;
    this.Limit.Start = 0;
    this.Limit.End = this.rowcount;
    this.getData();
  }

  onRowSelect(action: any, index?: any, rowData?: Object) {
    this.actionType = action;
    this.openDialog = true;
    this.dataService.roeSelectedRecords = [];
    this.getAddressData(rowData);
    this.getScreenData(rowData);

    if (action === 'Edit' || action === 'View') {
      this.dataService.roeSelectedRecords[0] = (rowData);
      this.rowDataforDialog = rowData;
      this.rowIndexForDialog = index;
    } else if (action == 'Add') {
      this.rowDataforDialog = [];
      this.rowIndexForDialog = 0;
    }
  }

  getAddressData(selectedRowDetail: any = {}) {
    /* Get all Address fields to Display */
    this.AddressGridColumns = _.sortBy(this.AddressGridColumns, 'sortOrder');
    this.AddressDataDetails = [];
    for (let i = 0; i < Object.keys(this.AddressGridColumns).length; i++) {
      this.AddressDataDetails.push({
        "ui_Field_Name": this.AddressGridColumns[i]["ui_columnname"],
        "field_Name": this.AddressGridColumns[i]["mappingkey"],
        "value": selectedRowDetail[this.AddressGridColumns[i]["db_columnname"]],
        "datatype": this.AddressGridColumns[i]["datatype"],
        "display": this.AddressGridColumns[i]["display"],
        "db_columnname": this.AddressGridColumns[i]["db_columnname"],
        "dropdown": this.AddressGridColumns[i]["dropdown"],
        "dropdowntype": this.AddressGridColumns[i]["dropdowntype"],
        "dropdownvalue": this.AddressGridColumns[i]["dropdownvalue"],
        "isDisable": this.AddressGridColumns[i]["disabled"],
        "placeholder": (this.AddressGridColumns[i]["placeholder"] ? this.AddressGridColumns[i]["placeholder"] : "Please Enter Value"),
        "maximumLength": (this.AddressGridColumns[i]["maxlength"] ? this.AddressGridColumns[i]["maxlength"] : ""),
        "isrequired": (this.AddressGridColumns[i]["isrequired"] ? this.AddressGridColumns[i]["isrequired"] : false),
        "regexpressions": (this.AddressGridColumns[i]["regexpressions"] ? this.AddressGridColumns[i]["regexpressions"] : "")
      });
    }

    /* Get all Address fields to Display */
    this.AddressDetails = [];
    if(Object.keys(selectedRowDetail).length > 0) {
      for(let j=1; j<=4; j++) {
        /* Retrieve Country & Region Code */
        let countryCode, regionCountryCode;
        if (this.actionType === 'Edit') {
          countryCode = _.find(this.UserService.countryList, {label:selectedRowDetail['addr'+j+'_countryCode']});
          regionCountryCode = _.find(this.UserService.countryRegionList, {label:selectedRowDetail['addr'+j+'_regionCode']});
        }
        let addressData={
          'addr_addrLine1': selectedRowDetail['addr'+j+'_addrLine1'],
          'addr_addrLine2': selectedRowDetail['addr'+j+'_addrLine2'],
          'addr_addrLine3': selectedRowDetail['addr'+j+'_addrLine3'],
          'addr_addrLine4': selectedRowDetail['addr'+j+'_addrLine4'],
          'addr_city': selectedRowDetail['addr'+j+'_city'],
          'addr_regionCode': (regionCountryCode ? regionCountryCode.value : selectedRowDetail['addr'+j+'_regionCode']),
          'addr_countryCode': (countryCode ? countryCode.value : selectedRowDetail['addr'+j+'_countryCode']),
          'addr_postalCode': selectedRowDetail['addr'+j+'_postalCode']
        }
        if(Object.values(addressData).some(value=>value && value.trim() !=='')){
          this.AddressDetails.push(addressData);
        }
      }
      /* Add a Blank Address Row if don't have any Addresses */
        if(this.AddressDetails.length === 0) {
          this.AddressDetails.push({
              'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
          });
        }
      /* End of Adding a Blank Address Row if don't have any Addresses */
    } else {
      this.AddressDetails.push({
          'addr_addrLine1': '', 'addr_addrLine2': '', 'addr_addrLine3': '', 'addr_addrLine4': '', 'addr_city': '', 'addr_regionCode': '', 'addr_countryCode': '', 'addr_postalCode': ''
        });
    }
  }

  getScreenData(selectedRowDetail: any = {}) {
    /* Get all Non-Address fields to Display */
    this.GridColumns = _.sortBy(this.GridColumns, 'sortOrder');
    this.screenDataDetails = [];
    for (let i = 0; i < Object.keys(this.GridColumns).length; i++) {
      /* Retrieve Foreign Country & Replacing Foreign Country */
        if (this.actionType === 'Edit') {
          if(_.includes(["Foreign TID Country", "Replacing Foreign TID Country"], this.GridColumns[i]["ui_columnname"])) {
            let countryCode = _.find(this.UserService.countryList, {label:selectedRowDetail[this.GridColumns[i]["db_columnname"]]});
            selectedRowDetail[this.GridColumns[i]["db_columnname"]] = (countryCode ? countryCode.value : selectedRowDetail[this.GridColumns[i]["db_columnname"]]);
          }
        }
      /* End of retrieving Foreign Country & Replacing Foreign Country */
      if(!(/Address Line|City|Region Code|Country Code|Postal Code/.test(this.GridColumns[i]["ui_columnname"]))) {
        this.screenDataDetails.push({
          "ui_Field_Name": this.GridColumns[i]["ui_columnname"],
          "field_Name": this.GridColumns[i]["mappingkey"],
          "value": selectedRowDetail[this.GridColumns[i]["db_columnname"]],
          "datatype": this.GridColumns[i]["datatype"],
          "display": this.GridColumns[i]["display"],
          "db_columnname": this.GridColumns[i]["db_columnname"],
          "dropdown": this.GridColumns[i]["dropdown"],
          "dropdowntype": this.GridColumns[i]["dropdowntype"],
          "dropdownvalue": _.includes(this.CountryFields, this.GridColumns[i]["ui_columnname"]) ? this.UserService.countryList : (this.GridColumns[i]["dropdown"]==="YES" && this.UserService.CAIS_Field_Dictionary[this.GridColumns[i]["db_columnname"]] ? _.cloneDeep(this.UserService.CAIS_Field_Dictionary[this.GridColumns[i]["db_columnname"]]) : this.GridColumns[i]["dropdownvalue"]),
          "isDisable": this.GridColumns[i]["disabled"],
          "placeholder": (this.GridColumns[i]["placeholder"] ? this.GridColumns[i]["placeholder"] : "Please Enter Value"),
          "maximumLength": (this.GridColumns[i]["maxlength"] ? this.GridColumns[i]["maxlength"] : ""),
          "isLargeField": (this.GridColumns[i]["isLargeFields"] ? this.GridColumns[i]["isLargeFields"] : false),
          "isrequired": (this.GridColumns[i]["isrequired"] ? this.GridColumns[i]["isrequired"] : false),
          "regexpressions": (this.GridColumns[i]["regexpressions"] ? this.GridColumns[i]["regexpressions"] : "")
        });
      }
    }
    /* Disabling TID Type Option */
      let NPTIDTypeObjIndex = this.screenDataDetails.findIndex((objElement: { ui_Field_Name: string; }) => objElement.ui_Field_Name === "TID Type");
      this.screenDataDetails[NPTIDTypeObjIndex]["dropdownvalue"].reduce(function (previousValue: any[], currentValue: { disabled: boolean; value: string; }) {
        currentValue.disabled = ((currentValue.value === 'EIN') ? true : false);
        previousValue.push(currentValue);
        return previousValue;
      }, []);
    /* End of Disabling TID Type Option */
  }

  insertScreenRow(eventData: any) {
    const formDataObj = this.prepareFormData(eventData);
    return this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.addNaturalPersonData
        ), {
          type: this.DefaultFilterArray[1].values,
          CATReporterIMID: this.UserService.getActiveMPID(),
          user: this.UserService.getUserFirstName(),
          userName: this.UserService.getUserName(),
          reportDate: this.UserService.getyyyyMMddDateFormate(new Date()),
          formData: formDataObj,
          createdUser: this.UserService.getUserFirstName()
        })
        .subscribe({
          next: (res:any) => {
          let dataset: any = res;
          if(dataset.status === true) {
            this.openDialog = false;
            this.getData();
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
          }
        }});
  }

  updateScreenRow(eventData: any) {
    const formDataObj = this.prepareFormData(eventData);
    return this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.addNaturalPersonData
        ), {
          type: this.DefaultFilterArray[1].values,
          CATReporterIMID: this.UserService.getActiveMPID(),
          user: this.UserService.getUserFirstName(),
          userName: this.UserService.getUserName(),
          reportDate: this.UserService.getyyyyMMddDateFormate(new Date()),
          formData: formDataObj,
          updatedUser: this.UserService.getUserFirstName()
        })
        .subscribe({
          next: (res:any) => {
          let dataset: any = res;
          if(dataset.status === true) {
            this.openDialog = false;
            this.getData();
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_SUCCESS, summary: this.constantService.MESSAGE_SUMMARY_SUCCESS, detail: dataset.message });
          } else {
            this.messageService.add({ severity: this.constantService.MESSAGE_SEVERITY_ERROR, summary: this.constantService.MESSAGE_SUMMARY_ERROR, detail: dataset.message });
          }
        }});
  }

  prepareFormData(eventData: { [x: string]: { [x: string]: any; }[]; }) {
    const columnsObj: any = {};

    if(eventData['screenData'].length > 0) {
      let columns = this.GridColumns.map(({ db_columnname }) => db_columnname);
      for(let i=0; i < columns.length; i++) {
        let searchField = eventData['screenData'].filter((fieldObj: any) => columns[i]===fieldObj.field_Name);
        if(Object.keys(searchField).length > 0) {
          columnsObj[columns[i]] = (_.includes(this.yearField, searchField[0]["ui_Field_Name"]) ? new Date(searchField[0]['value']).getFullYear().toString() : (searchField[0]['value'] ? searchField[0]['value'] : ''));
        }
      }
    }

    if(eventData['addressData'].length > 0) {
      this.dataService.formAddressDetails(this.AddressGridColumns, columnsObj, eventData['addressData']); // Assign Address Field Values
    }
    this.formatData(columnsObj); // Formatting Data
    return columnsObj;
  }

  formatData(DataObject: { [x: string]: any; }) {
    for (const key in DataObject) {
      const match = /(GMT.*\))/.exec(DataObject[key]);
      if(typeof DataObject[key] === 'object' && match && match.length > 0) {
        DataObject[key] = DataObject[key] ? format(new Date(DataObject[key]), 'yyyy-MM-dd') : '';
      } else if(typeof DataObject[key] === 'object' && DataObject[key] && DataObject[key].length > 0) {
        DataObject[key] = DataObject[key].join('@');
      } else {
        DataObject[key] = DataObject[key] ? DataObject[key] : null;
      }
    }
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Report Date', 'columnname': 'reportDate', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Record Type', 'columnname': 'staging', 'filterby': 'IS', 'values': 'STAGING', 'time': '', 'datatype': 'skip', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'singleSelect', 'dropdownvalue': [
        {'label': 'Not Submitted', 'value': 'STAGING', 'description': 'Access from Staging DB'},
        {'label': 'Submitted', 'value': 'MASTER', 'description': 'Access from Master DB'}],
        'module': 'CAIS'
      },
      { 'isdefault': 'true', 'label': 'Customer Record ID', 'columnname': 'id', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      { 'isdefault': 'true', 'label': 'In Customer Record ID', 'columnname': 'inCustomerRecordID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': ''},
      { 'isdefault': 'true', 'label': 'First Name', 'columnname': 'firstName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Middle Name', 'columnname': 'middleName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Last Name', 'columnname': 'lastName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Suffix', 'columnname': 'nameSuffix', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Doing Business As', 'columnname': 'doingBusinessAs', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Year of Birth', 'columnname': 'yearOfBirth', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'TID Value', 'columnname': 'tidValue', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
    this.getData();
  }

  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.endLimit = this.startLimit + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;

    this.getData();
  }

  getData() {
    this.dataService.roeSelectedRecords = [];
    this.dataset = [];
    this.isLoadingResults = true;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    /* set post dataset */
    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(
        APIURL.Natural_Person_List
      ), {
        type: this.DefaultFilterArray[1].values,
        CATReporterIMID: this.UserService.getActiveMPID(),
        user: this.UserService.getUserName(),
        userName: this.UserService.getUserFirstName(),
        data: filterData,
        startLimit: this.Limit.Start.toString(),
        endLimit: this.Limit.End.toString()
      }
    ).subscribe({
      next: (Element:any) => {
        let dataset: any = Element;
        this.dataset = dataset.Data;
        /* Displaying Country & Region Name */
        if(this.dataset.length > 0) {
          this.dataset.forEach(col => {
            for(let j=1; j<=4; j++) {
              let countryCode = _.find(this.UserService.countryList, {value:col['addr'+j+'_countryCode']});
              col['addr'+j+'_countryCode'] = (countryCode ? countryCode.label : col['addr'+j+'_countryCode']);
              let regionCountryCode = _.find(this.UserService.countryRegionList, {value:col['addr'+j+'_regionCode']});
              col['addr'+j+'_regionCode'] = (regionCountryCode ? regionCountryCode.label : col['addr'+j+'_regionCode']);
            }
          });
        }

        this.defaultData = this.dataset;
        this.dataset = _.orderBy(_.sortBy(this.dataset, this.sortData.field), [this.sortData.field], [this.sortData.order]);
        this.totalRecords = dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        if (this.dataset.length == 0) {
          this.tbldatamsg = "No data found";
        }
        this.isLoadingResults = false;
      },  error: (err: HttpErrorResponse) => {
        this.isLoadingResults = false;
    }});
  }

  exportToCSV(event: any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    // to let user know the button is clicked and download process is started
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });

    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = this.previousLimit;
    }

    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.UserService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    const exportCSVPayload = {
      "type": this.DefaultFilterArray[1].values,
      "CATReporterIMID": this.UserService.getActiveMPID(),
      "user": this.UserService.getUserName(),
      "userName": this.UserService.getUserFirstName(),
      "data": JSON.parse(JSON.stringify(filterData)),
      "startLimit": this.Limit.Start + "",
      "endLimit": this.Limit.End + "",
      "pageName": 'CAIS-Natural-Person'
    };

    this.sharedHttpClientService.post(
      this.urlService.setAPIURl(APIURL.Natural_Person_List),
      exportCSVPayload
    ).pipe(map((response: Response) => {
      return response;
    })).subscribe({
      next: (Element:any) => {
      this.isLoadingResults = false;

      let dataset: any = Element;
      let data = dataset.Data;

      /* Displaying Country & Region Name */
      if(data.length > 0) {
        data.forEach((col: { [x: string]: any; }) => {
          for(let j=1; j<=4; j++) {
            let countryCode = _.find(this.UserService.countryList, {value:col['addr'+j+'_countryCode']});
            col['addr'+j+'_countryCode'] = (countryCode ? countryCode.label : col['addr'+j+'_countryCode']);
            let regionCountryCode = _.find(this.UserService.countryRegionList, {value:col['addr'+j+'_regionCode']});
            col['addr'+j+'_regionCode'] = (regionCountryCode ? regionCountryCode.label : col['addr'+j+'_regionCode']);
          }
          /* Displying Country Fields */
          for(let i=0; i < this.CounryDBFields.length; i++) {
            let countryCode = _.find(this.UserService.countryList, {value:col[this.CounryDBFields[i]]});
            col[this.CounryDBFields[i]] = (countryCode ? countryCode.label : col[this.CounryDBFields[i]]);
          }
        });
      }

      if (data.length > 0) {
        const options: any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_CAIS_Natural_Person_' + this.UserService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.UserService.getActiveMPID() + '_RSMS_CAIS_Natual_Person_' + this.UserService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(data, event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);

        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.UserService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);
    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.UserService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }

  sort(event: any) {
    if(event.multisortmeta) {
      if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
        this.sortClickCounter = this.sortClickCounter + 1;
      } else {
        this.sortClickCounter = 1;
      }
      if (this.sortClickCounter !== 3) {
        let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
        this.sortData.field = event.multisortmeta[0].field;
        this.sortData.order = sortOrder;
        this.dataset = this.sortPipe.transform(this.dataset, this.sortData.order, this.sortData.field);
      } else {
        this.resetSort()
      }
    }

  }

  resetSort() {
    if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0;
    }

  this.dataset = this.defaultData;
}

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}